import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Document {
  name: string;
  api_token: string;
}

export interface DocumentListInfor {
  errors: unknown;
  document: Document;
  isAuthenticated: boolean;
}

@Module
export default class DocumentModule
  extends VuexModule
  implements DocumentListInfor
{
  errors = {};
  document = {} as Document;
  isAuthenticated = !!JwtService.getToken();

  get Documents() {
    return this.documentListData;
  }

  @Mutation
  [Mutations.DOCUMENTS_LIST_DATA](Documents) {
    this.documentListData = Documents;
  }

  @Action
  [Actions.DOCUMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("document/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DOCUMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("document", payload)
        .then((data) => {
          this.context.commit(Mutations.DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DOCUMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/document", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DOCUMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/document", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
